//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormGroupView from "@/0/components/comForm/comFormDetailGroupViewX";
export default {
  props: ["controlItem"],
  components: {
    "form-group-view": FormGroupView,
  },
  data() {
    return {

    };
  },
  created() {},

  methods: {
    async onTabPageChange(tabPageId, title) {
      console.log("onTabPageChange-name", title);
    }
  }
};
